import { jsx as s, jsxs as b, Fragment as xe } from "react/jsx-runtime";
import _, { useState as v, useEffect as N, useMemo as ve, useCallback as P, useRef as F } from "react";
import { R as ke } from "./chunks/ReorderList-DmGGgR8l.js";
import { f as we, i as Ie, c as W } from "./chunks/collabCloseCodes-DGgEuAqm.js";
import { a as Re } from "./chunks/syncClientInfo-D4E7fbgz.js";
const z = 32 * 1024;
function D(t) {
  return Math.min(
    t ?? z,
    z
  );
}
function j(t) {
  return "ref" in t ? t : { ref: t, label: t.sourceId };
}
new TextEncoder();
function Se(t, e) {
  return new Set(
    t.assignments.filter(
      (r) => r.target.kind === "user" && r.target.userId === e
    ).map((r) => r.askId)
  );
}
function Ee(t, e) {
  const r = Se(t, e);
  return t.asks.filter((n) => r.has(n.id));
}
function Ne(t) {
  const e = /* @__PURE__ */ new Map();
  for (const o of t.assignments) {
    if (o.target.kind !== "user") continue;
    const d = e.get(o.target.userId);
    d ? d.add(o.askId) : e.set(
      o.target.userId,
      /* @__PURE__ */ new Set([o.askId])
    );
  }
  const r = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Map();
  for (const o of t.responses) {
    if (!e.get(o.recipientUserId)?.has(o.askId))
      continue;
    r.add(`${o.recipientUserId}\0${o.askId}`);
    const d = n.get(o.recipientUserId);
    d ? d.add(o.askId) : n.set(
      o.recipientUserId,
      /* @__PURE__ */ new Set([o.askId])
    );
  }
  const i = t.recipients.filter((o) => {
    const d = e.get(o.userId);
    if (!d || d.size === 0) return !1;
    const a = n.get(o.userId);
    return !!a && [...d].every((g) => a.has(g));
  }).length;
  return {
    answeredAskCount: r.size,
    totalAssignedAskCount: t.assignments.length,
    answeredRecipientCount: i,
    totalRecipientCount: t.recipients.length,
    quorumReached: i >= t.quorum.requiredRecipientCount
  };
}
function qe(t, e) {
  if (!e || typeof e != "object") return !1;
  const r = e;
  if (r.type !== t.type) return !1;
  switch (t.type) {
    case "singleSelect":
      return typeof r.selectedId != "string" ? !1 : t.options.some((n) => n.id === r.selectedId) ? r.otherText === void 0 || typeof r.otherText == "string" : t.allowOther === !0 && r.selectedId === "__other__" && typeof r.otherText == "string" && r.otherText.trim().length > 0;
    case "multiSelect": {
      if (!Array.isArray(r.selectedIds) || !r.selectedIds.every((o) => typeof o == "string")) return !1;
      const n = r.selectedIds, i = new Set(t.items.map((o) => o.id));
      return new Set(n).size === n.length && n.every((o) => i.has(o)) && n.length >= (t.minSelected ?? 0) && n.length <= (t.maxSelected ?? t.items.length);
    }
    case "reorder": {
      if (!Array.isArray(r.orderedIds) || !Array.isArray(r.removedIds) || !r.orderedIds.every((a) => typeof a == "string") || !r.removedIds.every((a) => typeof a == "string")) return !1;
      const n = r.orderedIds, i = r.removedIds, o = new Map(t.items.map((a) => [a.id, a])), d = [...n, ...i];
      return new Set(d).size === d.length && d.length === o.size && d.every((a) => o.has(a)) && i.every((a) => o.get(a)?.removable === !0) && n.length >= Math.max(t.minItems ?? 0, 1);
    }
    case "editText": {
      if (typeof r.text != "string" || typeof r.edited != "boolean")
        return !1;
      const n = r.text.trim().length;
      return n >= (t.minLength ?? 0) && n <= D(t.maxLength);
    }
    case "confirm":
      return typeof r.value == "boolean";
    case "rating":
      return typeof r.value == "number" && Number.isFinite(r.value) && r.value >= t.min && r.value <= t.max;
  }
}
function Te(t, e) {
  const r = [], n = t.asks.find((d) => d.id === e.askId);
  e.requestId !== t.id && r.push({
    code: "requestMismatch",
    message: "Response requestId does not match the feedback request."
  }), t.lifecycle.status !== "open" && r.push({
    code: "requestNotOpen",
    message: "Only open feedback requests accept responses."
  }), n || r.push({ code: "unknownAsk", message: "Response askId is unknown." }), t.recipients.some(
    (d) => d.userId === e.recipientUserId
  ) || r.push({
    code: "unknownRecipient",
    message: "Response recipient is not part of the request."
  }), t.assignments.some(
    (d) => d.askId === e.askId && d.target.kind === "user" && d.target.userId === e.recipientUserId
  ) || r.push({
    code: "askNotAssigned",
    message: "The ask is not assigned to this recipient."
  });
  const i = e.answer, o = i && typeof i == "object" ? i.type : void 0;
  return n && n.type !== o ? r.push({
    code: "answerTypeMismatch",
    message: `Ask type ${n.type} cannot accept answer type ${String(o)}.`
  }) : n && !qe(n, i) && r.push({
    code: "invalidAnswer",
    message: "Response answer does not satisfy the ask's options or bounds."
  }), { valid: r.length === 0, errors: r };
}
function I(...t) {
  return t.filter(Boolean).join(" ");
}
const V = ({
  rootClassName: t,
  testId: e,
  state: r,
  tone: n,
  children: i
}) => /* @__PURE__ */ s(
  "div",
  {
    "data-testid": e,
    "data-state": r,
    className: I(
      t,
      "rounded-lg bg-nim-secondary border",
      n === "active" ? "border-nim-primary" : "border-nim",
      "overflow-hidden",
      n === "resolved" && "opacity-85"
    ),
    children: i
  }
), K = ({
  icon: t,
  title: e,
  trailing: r
}) => /* @__PURE__ */ b("div", { className: "flex items-center gap-2 py-3 px-4 border-b border-nim bg-nim-tertiary", children: [
  /* @__PURE__ */ s("div", { className: "w-5 h-5 text-nim-primary shrink-0", children: t }),
  /* @__PURE__ */ s("span", { className: "text-sm font-semibold text-nim flex-1", children: e }),
  r
] }), Ae = {
  success: "text-nim-success py-1 px-2 bg-[color-mix(in_srgb,var(--nim-success)_12%,transparent)]",
  muted: "text-nim-muted py-1 px-2 bg-nim-tertiary",
  primary: "text-nim-primary py-1 px-2 bg-[color-mix(in_srgb,var(--nim-primary)_12%,transparent)]",
  warning: "text-nim-warning py-1 px-2 bg-[color-mix(in_srgb,var(--nim-warning)_12%,transparent)]"
}, C = ({
  tone: t,
  testId: e,
  children: r
}) => /* @__PURE__ */ s(
  "span",
  {
    "data-testid": e,
    className: `flex items-center gap-1 text-xs font-medium ${Ae[t]} rounded-full`,
    children: r
  }
), Q = ({
  children: t
}) => /* @__PURE__ */ s("div", { className: "p-3 flex flex-col gap-3", children: t }), Ce = ({
  tag: t,
  hint: e,
  tagTone: r = "primary",
  question: n,
  selectableQuestion: i,
  rootClassName: o,
  testId: d,
  children: a
}) => /* @__PURE__ */ b(
  "div",
  {
    "data-testid": d,
    className: I(o, "bg-nim border border-nim rounded-md p-3"),
    children: [
      /* @__PURE__ */ b("div", { className: "flex items-center gap-2 mb-2", children: [
        /* @__PURE__ */ s(
          "span",
          {
            className: r === "primary" ? "text-[0.6875rem] font-semibold uppercase tracking-wide text-nim-primary bg-[color-mix(in_srgb,var(--nim-primary)_12%,transparent)] py-0.5 px-2 rounded-full" : "text-[0.6875rem] font-semibold uppercase tracking-wide text-nim-muted bg-nim-tertiary py-0.5 px-2 rounded-full",
            children: t
          }
        ),
        e && /* @__PURE__ */ s("span", { className: "text-[0.6875rem] text-nim-faint italic", children: e })
      ] }),
      n !== void 0 && /* @__PURE__ */ s(
        "div",
        {
          className: I(
            "text-sm text-nim leading-normal mb-3",
            i && "select-text"
          ),
          children: n
        }
      ),
      a
    ]
  }
), Y = ({
  children: t
}) => /* @__PURE__ */ s("div", { className: "flex flex-col gap-1.5", children: t }), _e = "w-4 h-4 mt-0.5 shrink-0 border rounded-sm flex items-center justify-center", Fe = () => /* @__PURE__ */ s("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ s(
  "path",
  {
    d: "M8.5 2.5L3.75 7.25L1.5 5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) }), J = ({
  label: t,
  description: e
}) => /* @__PURE__ */ b("div", { className: "flex flex-col gap-0.5 flex-1 min-w-0", children: [
  /* @__PURE__ */ s("span", { className: "text-[0.8125rem] font-medium text-nim leading-snug", children: t }),
  e && /* @__PURE__ */ s("span", { className: "text-xs text-nim-muted leading-snug", children: e })
] }), M = ({
  label: t,
  description: e,
  selected: r,
  onSelect: n,
  disabled: i,
  testId: o,
  dataAttributes: d
}) => {
  const a = /* @__PURE__ */ s(
    "div",
    {
      className: I(
        _e,
        n && "transition-colors",
        r ? "bg-nim-primary border-nim-primary text-nim-on-primary" : "bg-nim border-nim text-nim-primary"
      ),
      children: r && /* @__PURE__ */ s(Fe, {})
    }
  );
  return n ? /* @__PURE__ */ b(
    "button",
    {
      type: "button",
      "data-testid": o,
      ...d,
      onClick: n,
      disabled: i,
      className: I(
        "flex items-start gap-2 py-2 px-2.5 rounded border transition-all duration-150 cursor-pointer text-left bg-transparent disabled:opacity-50 disabled:cursor-not-allowed",
        r ? "border-nim-primary bg-[color-mix(in_srgb,var(--nim-primary)_8%,var(--nim-bg-secondary))]" : "border-nim bg-nim-secondary hover:bg-nim-hover"
      ),
      children: [
        a,
        /* @__PURE__ */ s(J, { label: t, description: e })
      ]
    }
  ) : /* @__PURE__ */ b(
    "div",
    {
      "data-testid": o,
      ...d,
      className: I(
        "flex items-start gap-2 py-2 px-2.5 rounded border cursor-default",
        r ? "border-nim-primary bg-[color-mix(in_srgb,var(--nim-primary)_8%,var(--nim-bg-secondary))]" : "border-nim bg-nim-secondary"
      ),
      children: [
        a,
        /* @__PURE__ */ s(J, { label: t, description: e })
      ]
    }
  );
}, X = ({
  icon: t,
  rootClassName: e,
  testId: r,
  children: n
}) => /* @__PURE__ */ b(
  "div",
  {
    "data-testid": r,
    className: I(
      e,
      "flex items-center gap-2 rounded-md border border-nim bg-nim px-3 py-2 text-xs text-nim-muted"
    ),
    children: [
      t && /* @__PURE__ */ s("span", { className: "w-3.5 h-3.5 shrink-0 text-nim-faint", children: t }),
      /* @__PURE__ */ s("span", { className: "select-text leading-snug", children: n })
    ]
  }
), Oe = ({ note: t, children: e }) => /* @__PURE__ */ b(
  "div",
  {
    className: I(
      "flex gap-2 justify-end",
      t ? "items-center" : void 0,
      "pt-2 border-t border-nim"
    ),
    children: [
      t && /* @__PURE__ */ s("span", { className: "mr-auto text-[0.6875rem] text-nim-faint leading-snug", children: t }),
      e
    ]
  }
), Me = ({
  onClick: t,
  testId: e,
  rootClassName: r,
  children: n
}) => /* @__PURE__ */ s(
  "button",
  {
    type: "button",
    "data-testid": e,
    onClick: t,
    className: I(
      r,
      "bg-transparent border-none p-0 text-[0.6875rem] text-nim-muted underline underline-offset-2 cursor-pointer hover:text-nim-primary"
    ),
    children: n
  }
), Le = ({
  variant: t,
  onClick: e,
  disabled: r,
  testId: n,
  children: i
}) => /* @__PURE__ */ s(
  "button",
  {
    type: "button",
    "data-testid": n,
    onClick: e,
    disabled: r,
    className: t === "primary" ? "px-4 py-1.5 rounded-md text-[13px] font-medium cursor-pointer border-none transition-colors duration-150 hover:opacity-90 bg-nim-primary text-nim-on-primary disabled:opacity-50 disabled:cursor-not-allowed" : "px-3 py-1.5 rounded-md text-[13px] cursor-pointer border border-nim transition-colors duration-150 hover:bg-nim-hover bg-nim-tertiary text-nim-muted disabled:opacity-50 disabled:cursor-not-allowed",
    children: i
  }
), je = 1e3, Ue = 3e4, H = 1e4;
function De(t) {
  return t.replace(/^https:/, "wss:").replace(/^http:/, "ws:").replace(/\/+$/, "");
}
function G(t) {
  return Ne({
    ...t,
    responses: []
  });
}
class S extends Error {
  code;
  constructor(e, r) {
    super(r), this.name = "FeedbackRequestSyncError", this.code = e;
  }
}
class mt {
  target;
  config;
  listeners = /* @__PURE__ */ new Set();
  pendingRequests = /* @__PURE__ */ new Map();
  snapshotWaiters = /* @__PURE__ */ new Set();
  ws = null;
  state = null;
  snapshotVersion = 0;
  syncRequested = !1;
  destroyed = !1;
  /** Server said this member may not be here. Terminal for reconnects only. */
  accessRevoked = !1;
  reconnectAttempt = 0;
  reconnectTimer = null;
  constructor(e) {
    this.config = e, this.target = e.target;
  }
  async connect() {
    if (this.destroyed) throw new Error("Feedback request sync has been destroyed");
    if (!this.ws) {
      this.accessRevoked = !1, this.emit({ type: "connecting" });
      try {
        const e = await this.config.getTeamJwt();
        if (this.destroyed || this.ws) return;
        const r = we(
          this.target.orgId,
          this.target.requestId
        ), n = Re(
          `${De(this.config.serverUrl)}/sync/${r}?token=${encodeURIComponent(e)}`
        ), i = this.config.createWebSocket ? this.config.createWebSocket(n) : new WebSocket(n);
        this.ws = i, i.addEventListener("open", () => {
          this.ws === i && (this.reconnectAttempt = 0, this.emit({ type: "connected" }), this.flushRequests());
        }), i.addEventListener("message", (o) => {
          this.ws === i && this.handleMessage(o.data);
        }), i.addEventListener("close", (o) => {
          if (this.ws !== i) return;
          this.ws = null;
          const d = o?.code, a = Ie(d);
          if (this.rejectRequests(new S(
            a ? "FEEDBACK_REQUEST_ACCESS_REVOKED" : "FEEDBACK_REQUEST_CONNECTION_CLOSED",
            a ? W(d) : "Feedback request connection closed before the request completed"
          )), this.emit({ type: "disconnected" }), a) {
            this.accessRevoked = !0, this.emit({
              type: "error",
              code: "FEEDBACK_REQUEST_ACCESS_REVOKED",
              message: W(d)
            });
            return;
          }
          this.scheduleReconnect();
        }), i.addEventListener("error", () => {
          this.ws === i && i.close();
        });
      } catch (e) {
        const r = e instanceof Error ? e : new Error(String(e));
        throw this.emit({
          type: "error",
          code: "FEEDBACK_REQUEST_CONNECTION_FAILED",
          message: r.message
        }), this.rejectRequests(r), this.scheduleReconnect(), r;
      }
    }
  }
  subscribe(e) {
    return this.listeners.add(e), () => {
      this.listeners.delete(e);
    };
  }
  getState() {
    return this.state;
  }
  async sync() {
    if (this.destroyed)
      throw new Error("Feedback request sync has been destroyed");
    const e = this.waitForSnapshot(this.snapshotVersion + 1);
    return this.syncRequested = !0, this.flushRequests(), e;
  }
  async create(e, r) {
    const n = await this.requestMutation({
      type: "feedbackRequestCreate",
      clientMutationId: e,
      request: r
    }, "feedbackRequestCreateAck");
    if (n.type !== "feedbackRequestCreateAck")
      throw this.unexpectedResponse("feedbackRequestCreateAck", n.type);
    return this.setState(
      n.request,
      this.state?.progress ?? G(n.request)
    );
  }
  async respond(e, r, n) {
    const i = await this.requestMutation({
      type: "feedbackResponse",
      clientMutationId: e,
      requestId: this.target.requestId,
      askId: r,
      answer: n
    }, "feedbackResponseAck");
    if (i.type !== "feedbackResponseAck")
      throw this.unexpectedResponse("feedbackResponseAck", i.type);
    if (!this.state)
      throw new S(
        "FEEDBACK_REQUEST_STATE_MISSING",
        "Feedback request must be synchronized before responding"
      );
    return this.state;
  }
  async comment(e, r, n) {
    const i = await this.requestMutation({
      type: "feedbackRequestComment",
      clientMutationId: e,
      requestId: this.target.requestId,
      body: r,
      replyToCommentId: n
    }, "feedbackRequestCommentAck");
    if (i.type !== "feedbackRequestCommentAck")
      throw this.unexpectedResponse("feedbackRequestCommentAck", i.type);
    return i.comment;
  }
  async close(e, r) {
    const n = await this.requestMutation({
      type: "feedbackRequestClose",
      clientMutationId: e,
      requestId: this.target.requestId,
      status: r
    }, "feedbackRequestCloseAck");
    if (n.type !== "feedbackRequestCloseAck")
      throw this.unexpectedResponse("feedbackRequestCloseAck", n.type);
    return this.setState(
      n.request,
      this.state?.progress ?? G(n.request)
    );
  }
  async nudge(e, r) {
    const n = await this.requestMutation({
      type: "feedbackRequestNudge",
      clientMutationId: e,
      requestId: this.target.requestId,
      recipientUserIds: r
    }, "feedbackRequestNudgeAck");
    if (n.type !== "feedbackRequestNudgeAck")
      throw this.unexpectedResponse("feedbackRequestNudgeAck", n.type);
    const i = {
      requestId: n.requestId,
      recipientUserIds: n.recipientUserIds,
      nudgedAt: n.nudgedAt
    };
    return this.emit({ type: "nudged", receipt: i }), i;
  }
  destroy() {
    this.destroyed = !0, this.reconnectTimer && clearTimeout(this.reconnectTimer), this.reconnectTimer = null;
    const e = this.ws;
    this.ws = null, e?.close(), this.rejectRequests(new S(
      "FEEDBACK_REQUEST_DESTROYED",
      "Feedback request sync was destroyed"
    )), this.listeners.clear();
  }
  requestMutation(e, r) {
    if (this.destroyed)
      return Promise.reject(new Error("Feedback request sync has been destroyed"));
    if (this.pendingRequests.has(e.clientMutationId))
      return Promise.reject(new S(
        "FEEDBACK_REQUEST_DUPLICATE_MUTATION",
        `Feedback request mutation ${e.clientMutationId} is already pending`
      ));
    const n = new Promise((i, o) => {
      const d = setTimeout(() => {
        this.pendingRequests.delete(e.clientMutationId), o(new S(
          "FEEDBACK_REQUEST_TIMEOUT",
          `Feedback request mutation ${e.clientMutationId} timed out`
        ));
      }, H);
      this.pendingRequests.set(e.clientMutationId, {
        message: e,
        expectedType: r,
        resolve: i,
        reject: o,
        timer: d,
        sent: !1
      });
    });
    return this.flushRequests(), n;
  }
  waitForSnapshot(e) {
    return new Promise((r, n) => {
      const i = {
        minimumVersion: e,
        resolve: r,
        reject: n,
        timer: setTimeout(() => {
          this.snapshotWaiters.delete(i), n(new S(
            "FEEDBACK_REQUEST_TIMEOUT",
            "Feedback request snapshot timed out"
          ));
        }, H)
      };
      this.snapshotWaiters.add(i);
    });
  }
  flushRequests() {
    if (!(!this.ws || this.ws.readyState !== WebSocket.OPEN)) {
      this.syncRequested && (this.syncRequested = !1, this.ws.send(JSON.stringify({ type: "feedbackRequestSync" })));
      for (const e of this.pendingRequests.values())
        e.sent || (e.sent = !0, this.ws.send(JSON.stringify(e.message)));
    }
  }
  handleMessage(e) {
    try {
      const r = JSON.parse(
        typeof e == "string" ? e : String(e)
      );
      if (r.type === "feedbackRequestEvent") {
        this.applyEvent(r.event);
        return;
      }
      if (r.type === "feedbackRequestError") {
        const n = new S(
          String(r.code ?? "FEEDBACK_REQUEST_ERROR"),
          String(r.message ?? "Feedback request failed")
        );
        this.emit({ type: "error", code: n.code, message: n.message }), this.rejectRequests(n);
        return;
      }
      if (r.type === "feedbackRequestSnapshot") {
        if (r.request.id !== this.target.requestId || r.request.orgId !== this.target.orgId) return;
        this.applySnapshot(r.request, r.progress);
        return;
      }
      this.finishMutation(r);
    } catch (r) {
      const n = r instanceof Error ? r : new Error(String(r));
      this.emit({
        type: "error",
        code: "FEEDBACK_REQUEST_PROTOCOL_ERROR",
        message: n.message
      }), this.rejectRequests(n);
    }
  }
  applyEvent(e) {
    e.type === "feedbackRequestNudged" && this.emit({
      type: "nudged",
      receipt: {
        requestId: e.requestId,
        recipientUserIds: e.recipientUserIds,
        nudgedAt: e.nudgedAt
      }
    });
  }
  unexpectedResponse(e, r) {
    return new S(
      "FEEDBACK_REQUEST_UNEXPECTED_RESPONSE",
      `Expected ${e} but received ${r}`
    );
  }
  setState(e, r) {
    return this.state = { request: e, progress: r }, this.emit({ type: "state", state: this.state }), this.state;
  }
  applySnapshot(e, r) {
    const n = this.setState(e, r);
    this.snapshotVersion += 1;
    for (const i of [...this.snapshotWaiters])
      i.minimumVersion > this.snapshotVersion || (this.snapshotWaiters.delete(i), clearTimeout(i.timer), i.resolve(n));
    return n;
  }
  finishMutation(e) {
    const r = this.pendingRequests.get(e.clientMutationId);
    !r || e.type !== r.expectedType || this.ackMatchesTarget(e) && (this.pendingRequests.delete(e.clientMutationId), clearTimeout(r.timer), r.resolve(e));
  }
  ackMatchesTarget(e) {
    return e.type === "feedbackRequestCreateAck" || e.type === "feedbackRequestCloseAck" ? e.request.id === this.target.requestId && e.request.orgId === this.target.orgId : e.type === "feedbackResponseAck" ? e.response.requestId === this.target.requestId : e.requestId === this.target.requestId;
  }
  rejectRequests(e) {
    for (const r of this.pendingRequests.values())
      clearTimeout(r.timer), r.reject(e);
    this.pendingRequests.clear();
    for (const r of this.snapshotWaiters)
      clearTimeout(r.timer), r.reject(e);
    this.snapshotWaiters.clear(), this.syncRequested = !1;
  }
  emit(e) {
    for (const r of this.listeners) r(e);
  }
  scheduleReconnect() {
    if (this.destroyed || this.accessRevoked || this.reconnectTimer) return;
    const e = Math.min(
      je * 2 ** this.reconnectAttempt,
      Ue
    );
    this.reconnectAttempt += 1, this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, this.connect().catch(() => {
      });
    }, e);
  }
}
const oe = "__other__", Be = {
  notARecipient: "Nothing on this request is assigned to you.",
  requestNotOpen: "This request is closed and no longer takes answers.",
  incomplete: "Answer every question before submitting.",
  rejected: "These answers were rejected before sending."
};
function B(t, e) {
  return e ? Ee(t, e) : [];
}
function $e(t, e) {
  const r = {};
  if (!e) return r;
  for (const n of t.responses)
    n.recipientUserId === e && (r[n.askId] = n.answer);
  return r;
}
function Pe(t) {
  switch (t.type) {
    case "singleSelect":
      return;
    case "multiSelect":
      return {
        type: "multiSelect",
        selectedIds: t.items.filter((e) => e.defaultChecked).map((e) => e.id)
      };
    case "reorder":
      return {
        type: "reorder",
        orderedIds: t.items.map((e) => e.id),
        removedIds: []
      };
    case "editText":
      return { type: "editText", text: t.initialText, edited: !1 };
    case "confirm":
      return t.defaultValue === void 0 ? void 0 : { type: "confirm", value: t.defaultValue };
    case "rating":
      return t.initialValue === void 0 ? void 0 : { type: "rating", value: t.initialValue };
  }
}
function We(t, e) {
  const r = $e(t, e), n = {};
  for (const i of B(t, e)) {
    const o = r[i.id] ?? Pe(i);
    o && (n[i.id] = o);
  }
  return { requestId: t.id, answers: n };
}
function ze(t, e, r) {
  return { ...t, answers: { ...t.answers, [e]: r } };
}
function Ve(t, e) {
  if (!e || e.type !== t.type) return !1;
  switch (t.type) {
    case "singleSelect":
      return e.type !== "singleSelect" ? !1 : e.selectedId === oe ? !!(e.otherText && e.otherText.trim()) : t.options.some((r) => r.id === e.selectedId);
    case "multiSelect":
      return e.type !== "multiSelect" ? !1 : e.selectedIds.length >= (t.minSelected ?? 0) && e.selectedIds.length <= (t.maxSelected ?? t.items.length);
    case "reorder":
      return e.type !== "reorder" ? !1 : e.orderedIds.length >= Math.max(t.minItems ?? 0, 1);
    case "editText": {
      if (e.type !== "editText") return !1;
      const r = e.text.trim().length;
      return r >= (t.minLength ?? 0) && r <= D(t.maxLength);
    }
    case "confirm":
      return e.type === "confirm";
    case "rating":
      return e.type === "rating" && e.value >= t.min && e.value <= t.max;
  }
}
function Z(t, e, r, n) {
  const i = B(t, e);
  if (i.length === 0)
    return { kind: "blocked", reason: "notARecipient" };
  if (t.lifecycle.status !== "open")
    return { kind: "blocked", reason: "requestNotOpen" };
  if (!i.every((a) => Ve(a, r.answers[a.id])))
    return { kind: "blocked", reason: "incomplete" };
  const o = i.map((a) => ({
    // Deterministic, and never sent: the wire carries only the ask id and the
    // answer, and the server stamps identity from the team JWT. This id exists
    // so the shared validator has a complete response to check.
    id: `${t.id}:${a.id}:${e}`,
    requestId: t.id,
    askId: a.id,
    recipientUserId: e,
    answer: r.answers[a.id],
    createdAt: n,
    updatedAt: n
  })), d = o.flatMap(
    (a) => Te(t, a).errors
  );
  return d.length > 0 ? { kind: "blocked", reason: "rejected", errors: d } : { kind: "ready", responses: o };
}
function ee(t, e) {
  return JSON.stringify(t.map((r) => [r.id, e.answers[r.id] ?? null]));
}
const Ke = ({ selected: t }) => /* @__PURE__ */ s(
  "span",
  {
    className: t ? "w-[15px] h-[15px] mt-0.5 shrink-0 rounded-full border border-nim-primary bg-nim-primary flex items-center justify-center" : "w-[15px] h-[15px] mt-0.5 shrink-0 rounded-full border border-nim-faint bg-nim flex items-center justify-center",
    children: t && /* @__PURE__ */ s("span", { className: "w-[5px] h-[5px] rounded-full bg-nim-on-primary" })
  }
), te = ({
  label: t,
  artifactLabel: e,
  note: r
}) => /* @__PURE__ */ b(
  "div",
  {
    className: "feedback-respond-option-placeholder flex h-full w-full flex-col items-center justify-center gap-1 rounded bg-nim-tertiary text-nim-faint",
    children: [
      /* @__PURE__ */ s("span", { "aria-hidden": "true", className: "text-lg font-semibold", children: t.trim().charAt(0).toUpperCase() || "?" }),
      e && /* @__PURE__ */ s("span", { className: "max-w-full truncate px-2 text-[0.6875rem] text-nim-muted", children: e }),
      r && /* @__PURE__ */ s("span", { className: "feedback-respond-option-placeholder-note max-w-full px-3 text-center text-[0.6875rem] leading-snug text-nim-faint", children: r })
    ]
  }
), Qe = ({
  askId: t,
  options: e,
  artifacts: r,
  selectedId: n,
  onSelect: i,
  disabled: o = !1,
  renderPreview: d,
  onExpand: a,
  resolveAction: g
}) => /* @__PURE__ */ s(
  "div",
  {
    "data-testid": "feedback-respond-option-cards",
    className: "feedback-respond-option-cards grid gap-2.5",
    style: { gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))" },
    children: e.map((c, f) => {
      const m = c.id === n, l = r?.find((x) => x.entryId === c.id), p = d?.(c, f, l), u = l ? g?.(l) : void 0, h = !!(l && a && (g === void 0 || u?.open));
      return /* @__PURE__ */ b(
        "div",
        {
          "data-testid": "feedback-respond-option-card",
          "data-ask-id": t,
          "data-option-id": c.id,
          "data-selected": m || void 0,
          className: m ? "feedback-respond-option-card relative overflow-hidden rounded-md border border-nim-primary bg-[color-mix(in_srgb,var(--nim-primary)_8%,var(--nim-bg-secondary))] shadow-[0_0_0_1px_var(--nim-primary)]" : "feedback-respond-option-card relative overflow-hidden rounded-md border border-nim bg-nim-secondary",
          children: [
            h && l ? /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                "data-testid": "feedback-respond-option-expand",
                "aria-label": `Open ${l.label}`,
                onClick: (x) => a?.(
                  l,
                  x.currentTarget.closest(".feedback-respond-option-card")
                ),
                className: "feedback-respond-option-preview relative block h-44 w-full border-b border-nim bg-nim p-2.5 text-left cursor-zoom-in hover:ring-1 hover:ring-inset hover:ring-nim-primary",
                children: p ?? /* @__PURE__ */ s(
                  te,
                  {
                    label: c.label,
                    artifactLabel: l.label
                  }
                )
              }
            ) : /* @__PURE__ */ s("div", { className: "feedback-respond-option-preview relative h-44 border-b border-nim bg-nim p-2.5", children: p ?? /* @__PURE__ */ s(
              te,
              {
                label: c.label,
                artifactLabel: l?.label
              }
            ) }),
            /* @__PURE__ */ b(
              "button",
              {
                type: "button",
                "data-testid": "feedback-respond-option-choose",
                onClick: () => i(c.id),
                disabled: o,
                "aria-pressed": m,
                className: "flex w-full items-start gap-2 bg-transparent border-none px-2.5 py-2.5 text-left cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 hover:bg-nim-hover",
                children: [
                  /* @__PURE__ */ s(Ke, { selected: m }),
                  /* @__PURE__ */ b("span", { className: "flex min-w-0 flex-col gap-0.5", children: [
                    /* @__PURE__ */ s("span", { className: "text-xs font-semibold leading-snug text-nim select-text", children: c.label }),
                    c.description && /* @__PURE__ */ s("span", { className: "text-[0.6875rem] leading-snug text-nim-muted select-text", children: c.description })
                  ] })
                ]
              }
            )
          ]
        },
        c.id
      );
    })
  }
), Ye = _.lazy(async () => ({
  default: (await import("./chunks/FeedbackArtifactDetailPopover-CRNwUTxH.js")).FeedbackArtifactDetailPopover
})), re = ((t) => /* @__PURE__ */ s(_.Suspense, { fallback: null, children: /* @__PURE__ */ s(Ye, { ...t }) }));
function ne(t, e) {
  if (!t?.length) return [];
  const r = [];
  for (const n of e) {
    const i = t.find((o) => o.entryId === n.id);
    i && r.push({ entryId: n.id, artifact: i, label: n.label });
  }
  return r;
}
const Je = ({ artifact: t, onExpand: e }) => /* @__PURE__ */ s(
  "button",
  {
    type: "button",
    "data-testid": "feedback-respond-reorder-open",
    "aria-label": `Open ${t.label}`,
    onClick: (r) => e(r.currentTarget),
    className: "feedback-respond-reorder-artifact-button shrink-0 rounded border border-nim bg-nim px-1.5 py-0.5 text-[0.6875rem] text-nim-muted cursor-pointer hover:text-nim",
    children: "Open"
  }
), Xe = ({
  ask: t,
  answer: e,
  onChange: r,
  disabled: n = !1,
  renderOptionPreview: i,
  onExpandArtifact: o,
  renderArtifactDetail: d,
  resolveArtifactAction: a
}) => {
  const g = "artifacts" in t ? t.artifacts : void 0, [c, f] = _.useState(null), m = _.useCallback(
    (l, p) => {
      if (!d) {
        const u = a?.(l).open;
        u ? u() : o?.(l);
        return;
      }
      f({ entryId: l.entryId, anchor: p });
    },
    [d, a, o]
  );
  switch (t.type) {
    case "singleSelect": {
      const l = e?.type === "singleSelect" ? e.selectedId : void 0, p = e?.type === "singleSelect" ? e.otherText ?? "" : "";
      return /* @__PURE__ */ b("div", { className: "feedback-respond-single-select flex flex-col gap-2", children: [
        /* @__PURE__ */ s(
          Qe,
          {
            askId: t.id,
            options: t.options,
            artifacts: g,
            selectedId: l,
            disabled: n,
            renderPreview: i,
            onExpand: m,
            resolveAction: a,
            onSelect: (u) => r({ type: "singleSelect", selectedId: u })
          }
        ),
        c && d && /* @__PURE__ */ s(
          re,
          {
            entries: ne(
              g,
              t.options.map((u) => ({ id: u.id, label: u.label }))
            ),
            activeEntryId: c.entryId,
            onActiveEntryChange: (u) => f((h) => h && { ...h, entryId: u }),
            onDismiss: () => f(null),
            anchor: c.anchor,
            renderArtifact: d,
            selectedId: l,
            disabled: n,
            onSelect: (u) => r({ type: "singleSelect", selectedId: u }),
            onOpenInTab: o
          }
        ),
        t.allowOther && /* @__PURE__ */ s(
          "input",
          {
            type: "text",
            "data-testid": "feedback-respond-other",
            value: p,
            disabled: n,
            placeholder: "Something else…",
            onChange: (u) => r({
              type: "singleSelect",
              selectedId: oe,
              otherText: u.target.value
            }),
            className: "feedback-respond-other-input w-full rounded border border-nim bg-nim px-2.5 py-2 text-[0.8125rem] text-nim placeholder-nim-faint focus:border-nim-primary focus:outline-none disabled:opacity-50"
          }
        )
      ] });
    }
    case "multiSelect": {
      const l = e?.type === "multiSelect" ? e.selectedIds : [], p = t.maxSelected ?? t.items.length;
      return /* @__PURE__ */ s(Y, { children: t.items.map((u) => {
        const h = l.includes(u.id);
        return /* @__PURE__ */ s(
          M,
          {
            testId: "feedback-respond-multi-option",
            dataAttributes: { "data-option-id": u.id },
            label: u.title,
            description: u.subtitle,
            selected: h,
            disabled: n || !h && l.length >= p,
            onSelect: () => r({
              type: "multiSelect",
              selectedIds: h ? l.filter((x) => x !== u.id) : [...l, u.id]
            })
          },
          u.id
        );
      }) });
    }
    case "reorder": {
      const l = e?.type === "reorder" ? { orderedIds: e.orderedIds, removedIds: e.removedIds } : { orderedIds: t.items.map((p) => p.id), removedIds: [] };
      return /* @__PURE__ */ b(xe, { children: [
        /* @__PURE__ */ s(
          ke,
          {
            items: t.items,
            state: l,
            minItems: t.minItems,
            disabled: n,
            rootClassName: "feedback-respond-reorder",
            testIds: {
              root: `feedback-respond-reorder-${t.id}`,
              row: "feedback-respond-reorder-row",
              remove: "feedback-respond-reorder-remove"
            },
            renderTrailing: o || a || d ? (p) => {
              const u = g?.find((h) => h.entryId === p);
              return !u || a && !a(u).open ? null : /* @__PURE__ */ s(
                Je,
                {
                  artifact: u,
                  onExpand: (h) => m(u, h)
                }
              );
            } : void 0,
            onChange: (p) => r({ type: "reorder", ...p })
          }
        ),
        c && d && /* @__PURE__ */ s(
          re,
          {
            entries: ne(
              g,
              // Ranking order, so stepping through the popover walks the list
              // the way it currently reads on screen rather than the order the
              // ask was authored in.
              l.orderedIds.map((p) => t.items.find((u) => u.id === p)).filter((p) => p !== void 0).map((p) => ({ id: p.id, label: p.title }))
            ),
            activeEntryId: c.entryId,
            onActiveEntryChange: (p) => f((u) => u && { ...u, entryId: p }),
            onDismiss: () => f(null),
            anchor: c.anchor,
            renderArtifact: d,
            onOpenInTab: o
          }
        )
      ] });
    }
    case "editText": {
      const l = e?.type === "editText" ? e.text : t.initialText;
      return /* @__PURE__ */ s(
        "textarea",
        {
          "data-testid": "feedback-respond-edit-text",
          value: l,
          rows: 3,
          disabled: n,
          placeholder: t.placeholder,
          maxLength: D(t.maxLength),
          onChange: (p) => r({
            type: "editText",
            text: p.target.value,
            edited: p.target.value !== t.initialText
          }),
          className: "feedback-respond-edit-text w-full resize-y rounded border border-nim bg-nim px-2.5 py-2 text-[0.8125rem] text-nim placeholder-nim-faint focus:border-nim-primary focus:outline-none disabled:opacity-50 select-text"
        }
      );
    }
    case "confirm": {
      const l = e?.type === "confirm" ? e.value : void 0;
      return /* @__PURE__ */ b(Y, { children: [
        /* @__PURE__ */ s(
          M,
          {
            testId: "feedback-respond-confirm-yes",
            label: "Yes",
            selected: l === !0,
            disabled: n,
            onSelect: () => r({ type: "confirm", value: !0 })
          }
        ),
        /* @__PURE__ */ s(
          M,
          {
            testId: "feedback-respond-confirm-no",
            label: "No",
            selected: l === !1,
            disabled: n,
            onSelect: () => r({ type: "confirm", value: !1 })
          }
        )
      ] });
    }
    case "rating": {
      const l = e?.type === "rating" ? e.value : void 0, p = t.step && t.step > 0 ? t.step : 1, u = [];
      for (let h = t.min; h <= t.max; h += p)
        u.push(h);
      return /* @__PURE__ */ b("div", { className: "feedback-respond-rating flex flex-col gap-1.5", children: [
        /* @__PURE__ */ s("div", { className: "flex flex-wrap gap-1.5", children: u.map((h) => /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            "data-testid": "feedback-respond-rating-step",
            "data-value": h,
            disabled: n,
            "aria-pressed": l === h,
            onClick: () => r({ type: "rating", value: h }),
            className: l === h ? "min-w-8 rounded border border-nim-primary bg-nim-primary px-2 py-1 text-xs font-semibold text-nim-on-primary cursor-pointer disabled:opacity-50" : "min-w-8 rounded border border-nim bg-nim-secondary px-2 py-1 text-xs text-nim-muted cursor-pointer hover:bg-nim-hover disabled:opacity-50",
            children: h
          },
          h
        )) }),
        (t.minLabel || t.maxLabel) && /* @__PURE__ */ b("div", { className: "flex justify-between text-[0.6875rem] text-nim-faint", children: [
          /* @__PURE__ */ s("span", { children: t.minLabel }),
          /* @__PURE__ */ s("span", { children: t.maxLabel })
        ] })
      ] });
    }
  }
}, se = {
  document: "Document",
  tracker: "Tracker item",
  file: "File",
  session: "Session",
  commit: "Commit",
  pullRequest: "Pull request",
  conversation: "Conversation",
  feedbackRequest: "Feedback request"
}, L = ({ subject: t, unavailableReason: e }) => /* @__PURE__ */ b("span", { className: "feedback-artifact-subject-body flex min-w-0 flex-col gap-0.5 text-left", children: [
  /* @__PURE__ */ s("span", { className: "truncate text-xs font-semibold leading-snug text-nim", children: t.label }),
  /* @__PURE__ */ s("span", { className: "truncate text-[0.6875rem] leading-snug text-nim-muted", children: t.context ? `${se[t.ref.kind]} · ${t.context}` : se[t.ref.kind] }),
  e && /* @__PURE__ */ s("span", { className: "feedback-artifact-unavailable-reason text-[0.6875rem] leading-snug text-nim-faint", children: e })
] }), He = ({
  subjects: t,
  onOpen: e,
  resolveAction: r,
  renderPreview: n,
  onExpand: i
}) => {
  if (!t?.length) return null;
  const o = n ? t.map((a, g) => n(j(a), g)) : [], d = o.some((a) => a != null);
  return /* @__PURE__ */ s(
    "div",
    {
      "data-testid": "feedback-artifact-subjects",
      "data-has-previews": d || void 0,
      className: d ? "feedback-artifact-subjects grid gap-2.5" : "feedback-artifact-subjects flex flex-col gap-1.5",
      style: d ? { gridTemplateColumns: "repeat(auto-fit, minmax(360px, 1fr))" } : void 0,
      children: t.map((a, g) => {
        const c = j(a), f = `${c.ref.kind}\0${c.ref.sourceId}\0${g}`, m = r?.(c) ?? (e ? { open: () => e(c) } : {}), l = o[g];
        if (l != null) {
          const u = !!i || !!m.open;
          return /* @__PURE__ */ b(
            "div",
            {
              "data-testid": "feedback-artifact-subject",
              "data-subject-kind": c.ref.kind,
              className: "feedback-artifact-subject feedback-artifact-subject-card overflow-hidden rounded border border-nim bg-nim-secondary",
              children: [
                u ? /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    "data-testid": "feedback-artifact-subject-expand",
                    "aria-label": `Open ${c.label}`,
                    onClick: (h) => {
                      const x = h.currentTarget.closest(".feedback-artifact-subject");
                      i ? i(c, x) : m.open?.();
                    },
                    className: "feedback-artifact-subject-preview relative block h-64 w-full border-b border-nim bg-nim p-2.5 text-left cursor-zoom-in hover:ring-1 hover:ring-inset hover:ring-nim-primary",
                    children: l
                  }
                ) : /* @__PURE__ */ s("div", { className: "feedback-artifact-subject-preview relative h-64 border-b border-nim bg-nim p-2.5", children: l }),
                /* @__PURE__ */ s("div", { className: "flex items-center gap-2 px-2.5 py-2 select-text", children: /* @__PURE__ */ s(L, { subject: c, unavailableReason: m.unavailableReason }) })
              ]
            },
            f
          );
        }
        const p = "flex w-full items-center gap-2 rounded border border-nim bg-nim-secondary px-2.5 py-2";
        return m.open ? /* @__PURE__ */ b(
          "button",
          {
            type: "button",
            "data-testid": "feedback-artifact-subject",
            "data-subject-kind": c.ref.kind,
            onClick: m.open,
            className: `feedback-artifact-subject ${p} cursor-pointer text-left hover:bg-nim-hover`,
            children: [
              /* @__PURE__ */ s(L, { subject: c }),
              /* @__PURE__ */ s("span", { className: "ml-auto shrink-0 text-[0.6875rem] text-nim-faint", children: "Open" })
            ]
          },
          f
        ) : /* @__PURE__ */ s(
          "div",
          {
            "data-testid": "feedback-artifact-subject",
            "data-subject-kind": c.ref.kind,
            className: `feedback-artifact-subject ${p} select-text`,
            children: /* @__PURE__ */ s(
              L,
              {
                subject: c,
                unavailableReason: m.unavailableReason
              }
            )
          },
          f
        );
      })
    }
  );
}, Ge = {
  singleSelect: "pick one",
  multiSelect: "pick any",
  reorder: "drag to rank — top is first",
  editText: "free text",
  confirm: "yes or no",
  rating: "rating"
}, ie = () => /* @__PURE__ */ b("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", className: "w-full h-full", children: [
  /* @__PURE__ */ s(
    "path",
    {
      d: "M2 4.5A1.5 1.5 0 0 1 3.5 3h9A1.5 1.5 0 0 1 14 4.5v6A1.5 1.5 0 0 1 12.5 12H6l-3 2.2V12h-.5A1.5 1.5 0 0 1 1 10.5v-6",
      stroke: "currentColor",
      strokeWidth: "1.3",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s("circle", { cx: "6", cy: "7.5", r: "0.9", fill: "currentColor" }),
  /* @__PURE__ */ s("circle", { cx: "9", cy: "7.5", r: "0.9", fill: "currentColor" })
] }), Ze = () => /* @__PURE__ */ b("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", className: "w-full h-full", children: [
  /* @__PURE__ */ s("rect", { x: "2.5", y: "6", width: "9", height: "6.2", rx: "1.2", stroke: "currentColor", strokeWidth: "1.2" }),
  /* @__PURE__ */ s("path", { d: "M4.6 6V4.4a2.4 2.4 0 0 1 4.8 0V6", stroke: "currentColor", strokeWidth: "1.2" })
] });
function et(t, e) {
  return t - e <= 0 ? "Past due" : `Due ${new Date(t).toLocaleString(void 0, {
    weekday: "short",
    hour: "numeric",
    minute: "2-digit"
  })}`;
}
const ft = ({
  state: t,
  host: e,
  discussion: r,
  renderOptionPreview: n,
  renderSubjectPreview: i,
  renderArtifactDetail: o,
  onOpenSubject: d,
  resolveArtifactAction: a,
  now: g
}) => {
  const c = t.request, f = t.teamMemberId, [m, l] = v(null), [p, u] = v(!1), [h, x] = v(null), [$, ue] = v(null), [pe, me] = v(!1), [A] = v(() => g ?? Date.now());
  N(() => {
    !c || !f || l((y) => y && y.requestId === c.id ? y : We(c, f));
  }, [c, f]);
  const E = ve(
    () => c ? B(c, f) : [],
    [c, f]
  ), fe = P((y, k) => {
    x(null), l((R) => R && ze(R, y, k));
  }, []), he = P(async () => {
    if (!c || !m || !e) return;
    const y = Z(c, f, m, A);
    if (y.kind === "ready") {
      u(!0), x(null);
      try {
        const k = await e.submitAnswers(
          y.responses.map((R) => ({
            askId: R.askId,
            answer: R.answer
          }))
        );
        k.success ? ue(ee(E, m)) : x(k.error ?? "Your answers could not be sent.");
      } catch (k) {
        console.error("[FeedbackRequestRespond] Failed to submit:", k), x(
          k instanceof Error ? k.message : "Your answers could not be sent."
        );
      } finally {
        u(!1);
      }
    }
  }, [c, m, e, f, A, E]);
  if (!c)
    return /* @__PURE__ */ b(
      V,
      {
        rootClassName: "feedback-request-respond",
        testId: "feedback-request-respond",
        state: t.status === "error" ? "error" : "loading",
        tone: "resolved",
        children: [
          /* @__PURE__ */ s(K, { icon: /* @__PURE__ */ s(ie, {}), title: "Feedback request" }),
          /* @__PURE__ */ s(Q, { children: /* @__PURE__ */ s("div", { className: "text-xs text-nim-muted select-text", children: t.error?.message ?? "Loading this request…" }) })
        ]
      }
    );
  const O = m ? Z(c, f, m, A) : { kind: "blocked", reason: "incomplete" }, q = $ !== null, be = !!(m && q && ee(E, m) === $), T = E.length > 0, ge = !!e && !p, ye = h || (O.kind === "blocked" ? Be[O.reason] : e ? q ? "Your answers are in. Change one to send an update." : "Your answers go to the person who asked, not the whole room." : "Answering is not available in this session yet.");
  return /* @__PURE__ */ b(
    V,
    {
      rootClassName: "feedback-request-respond @container/feedback-respond",
      testId: "feedback-request-respond",
      state: q ? "submitted" : T ? "open" : "observing",
      tone: q || !T ? "resolved" : "active",
      children: [
        /* @__PURE__ */ s(
          K,
          {
            icon: /* @__PURE__ */ s(ie, {}),
            title: "Feedback request",
            trailing: /* @__PURE__ */ b("span", { className: "flex items-center gap-1.5", children: [
              q ? /* @__PURE__ */ s(C, { tone: "success", testId: "feedback-respond-status", children: "Answers submitted" }) : T ? /* @__PURE__ */ s(C, { tone: "primary", testId: "feedback-respond-status", children: E.length === 1 ? "1 ask for you" : `${E.length} asks for you` }) : /* @__PURE__ */ s(C, { tone: "muted", testId: "feedback-respond-status", children: "Nothing for you" }),
              c.deadline !== void 0 && /* @__PURE__ */ s(C, { tone: "warning", children: et(c.deadline, A) })
            ] })
          }
        ),
        /* @__PURE__ */ b(Q, { children: [
          /* @__PURE__ */ s(
            He,
            {
              subjects: c.subjects,
              onOpen: d,
              renderPreview: i,
              resolveAction: a
            }
          ),
          E.map((y, k) => /* @__PURE__ */ s(
            Ce,
            {
              testId: "feedback-respond-ask",
              rootClassName: "feedback-respond-ask",
              tag: `Q${k + 1} · ${y.label}`,
              hint: Ge[y.type],
              question: y.description || y.label,
              selectableQuestion: !0,
              children: /* @__PURE__ */ s(
                Xe,
                {
                  ask: y,
                  answer: m?.answers[y.id],
                  disabled: p || c.lifecycle.status !== "open",
                  renderOptionPreview: n,
                  renderArtifactDetail: o,
                  onExpandArtifact: d,
                  resolveArtifactAction: a,
                  onChange: (R) => fe(y.id, R)
                }
              )
            },
            y.id
          )),
          !T && /* @__PURE__ */ s(
            X,
            {
              rootClassName: "feedback-respond-observer-note",
              testId: "feedback-respond-observer-note",
              children: "Nothing on this request is assigned to you. You can still follow the discussion."
            }
          ),
          c.visibility === "hiddenUntilAnswered" && T && /* @__PURE__ */ s(
            X,
            {
              icon: /* @__PURE__ */ s(Ze, {}),
              rootClassName: "feedback-respond-hidden-note",
              testId: "feedback-respond-hidden-note",
              children: "Other people's answers stay hidden until you submit yours."
            }
          ),
          /* @__PURE__ */ s(
            Oe,
            {
              note: /* @__PURE__ */ b("span", { className: "flex flex-wrap items-center gap-2", children: [
                /* @__PURE__ */ s("span", { children: ye }),
                /* @__PURE__ */ s(
                  Me,
                  {
                    testId: "feedback-respond-add-comment",
                    rootClassName: "feedback-respond-add-comment",
                    onClick: () => me(!0),
                    children: "Add a comment"
                  }
                )
              ] }),
              children: T && /* @__PURE__ */ s(
                Le,
                {
                  variant: "primary",
                  testId: "feedback-respond-submit",
                  onClick: () => {
                    he();
                  },
                  disabled: O.kind === "blocked" || !ge || be,
                  children: p ? "Sending…" : q ? "Update answers" : "Submit answers"
                }
              )
            }
          )
        ] }),
        (pe || (c.discussion?.length ?? 0) > 0) && /* @__PURE__ */ b(
          "div",
          {
            "data-testid": "feedback-respond-discussion",
            className: "feedback-respond-discussion border-t border-nim bg-nim-secondary px-3.5 py-3",
            children: [
              /* @__PURE__ */ b("div", { className: "mb-2 text-[0.6875rem] font-semibold uppercase tracking-wide text-nim-faint", children: [
                "Discussion",
                c.discussion?.length ? ` · ${c.discussion.length}` : ""
              ] }),
              r ?? /* @__PURE__ */ s(
                "div",
                {
                  "data-testid": "feedback-respond-discussion-unavailable",
                  className: "text-xs text-nim-muted select-text",
                  children: "Commenting on this request is not available here yet."
                }
              )
            ]
          }
        )
      ]
    }
  );
};
function de(t, e) {
  return `subject\0${t.ref.kind}\0${t.ref.sourceId}\0${e}`;
}
function tt(t, e) {
  return { ...t, entryId: de(t, e) };
}
function ht(t) {
  return t.map((e, r) => {
    const n = j(e);
    return {
      entryId: de(n, r),
      artifact: tt(n, r),
      // The subject's own name. There is no entry label to prefer over it, the
      // way an option's label outranks its artifact's.
      label: n.label
    };
  });
}
const ae = 800, bt = ({
  children: t,
  authoredWidth: e = ae
}) => {
  const r = F(null), [n, i] = v(null);
  N(() => {
    const d = r.current;
    if (!d || typeof ResizeObserver > "u") return;
    const a = new ResizeObserver(([g]) => {
      const c = g?.contentRect;
      c && i({ width: c.width, height: c.height });
    });
    return a.observe(d), () => a.disconnect();
  }, []);
  const o = n ? n.width / e : 0;
  return /* @__PURE__ */ s(
    "div",
    {
      ref: r,
      "aria-hidden": "true",
      "data-testid": "feedback-scaled-preview",
      className: "feedback-scaled-preview relative h-full w-full overflow-hidden rounded bg-nim-tertiary",
      children: n && /* @__PURE__ */ s(
        "div",
        {
          className: "absolute left-0 top-0 origin-top-left",
          style: {
            width: e,
            // Enough vertical extent that the child lays out as it would in a
            // real window; the frame's overflow crops whatever runs past.
            height: n.height / (o || 1),
            transform: `scale(${o})`,
            pointerEvents: "none"
          },
          children: t
        }
      )
    }
  );
}, gt = ({
  children: t,
  authoredWidth: e = ae
}) => {
  const r = F(null), [n, i] = v(null);
  N(() => {
    const a = r.current;
    if (!a || typeof ResizeObserver > "u") return;
    const g = new ResizeObserver(([c]) => {
      const f = c?.contentRect;
      f && i({ width: f.width, height: f.height });
    });
    return g.observe(a), () => g.disconnect();
  }, []);
  const o = n ? Math.min(1, n.width / e) : 1, d = o < 1;
  return /* @__PURE__ */ s(
    "div",
    {
      ref: r,
      "data-testid": "feedback-artifact-viewport",
      "data-scaled": d || void 0,
      className: "feedback-artifact-viewport relative h-full w-full overflow-hidden bg-nim",
      children: !d || !n ? /* @__PURE__ */ s("div", { className: "absolute inset-0", children: t }) : /* @__PURE__ */ s(
        "div",
        {
          className: "absolute left-0 top-0 origin-top-left",
          style: {
            // Laid out at authored width, then scaled to fit. The height is
            // divided by the same factor so the child still receives exactly
            // one boxful, rather than a short box with its bottom cropped.
            width: e,
            height: n.height / o,
            transform: `scale(${o})`
          },
          children: t
        }
      )
    }
  );
};
function rt(t, e) {
  return !Number.isFinite(t) || !Number.isFinite(e) || e <= 0 ? 0 : ce(t / e);
}
function nt(t, e) {
  return !Number.isFinite(t) || !Number.isFinite(e) || e <= 0 ? 0 : ce(t) * e;
}
function yt(t, e, r) {
  return nt(
    rt(t, e),
    r
  );
}
function ce(t) {
  return Number.isNaN(t) || t < 0 ? 0 : t > 1 ? 1 : t;
}
const st = 4, w = /* @__PURE__ */ new Set(), U = /* @__PURE__ */ new Set();
function le() {
  for (const t of U) t();
}
function xt() {
  w.clear(), le();
}
function vt() {
  return w.size;
}
function it() {
  let t = null;
  for (const e of w)
    e.priority || (t = e);
  return t;
}
function ot(t) {
  if (w.has(t)) return !0;
  if (w.size < st)
    return w.add(t), !0;
  if (!t.priority) return !1;
  const e = it();
  return e ? (w.delete(e), w.add(t), e.yieldSlot(), !0) : !1;
}
function dt(t) {
  w.delete(t) && le();
}
function kt(t, e = {}) {
  const { priority: r = !1 } = e, n = F(null), [i, o] = v(!1), [d, a] = v(!1), [g, c] = v(0), f = F(null);
  return f.current === null && (f.current = { priority: r, yieldSlot: () => a(!1) }), f.current.priority = r, N(() => {
    const m = () => c((l) => l + 1);
    return U.add(m), () => {
      U.delete(m);
    };
  }, []), N(() => {
    const m = n.current;
    if (!t || !m) return;
    if (typeof IntersectionObserver > "u") {
      o(!0);
      return;
    }
    const l = new IntersectionObserver((p) => {
      p.some((u) => u.isIntersecting) && o(!0);
    });
    return l.observe(m), () => l.disconnect();
  }, [t]), N(() => {
    const m = f.current;
    if (m) {
      if (!t && d) {
        a(!1);
        return;
      }
      !t || !i || d || ot(m) && a(!0);
    }
  }, [t, i, d, g, r]), N(() => {
    if (d)
      return () => {
        const m = f.current;
        m && dt(m);
      };
  }, [d]), { ref: n, mounted: t && d };
}
export {
  gt as ArtifactViewport,
  Be as FEEDBACK_RESPOND_BLOCKED_MESSAGES,
  He as FeedbackArtifactSubjects,
  te as FeedbackOptionPlaceholderPreview,
  ft as FeedbackRequestRespond,
  mt as FeedbackRequestSync,
  S as FeedbackRequestSyncError,
  Xe as FeedbackRespondAskField,
  Qe as FeedbackRespondOptionCards,
  st as MAX_CONCURRENT_LIVE_PREVIEWS,
  oe as OTHER_OPTION_ID,
  ae as PREVIEW_AUTHORED_WIDTH,
  bt as ScaledPreviewFrame,
  $e as attributedAnswersForViewer,
  yt as carryScrollTop,
  B as feedbackRespondAsks,
  ee as feedbackRespondSignature,
  Z as feedbackRespondSubmitPlan,
  tt as feedbackSubjectAsAskArtifact,
  ht as feedbackSubjectDetailEntries,
  de as feedbackSubjectEntryId,
  We as initialFeedbackRespondDraft,
  Ve as isAnswerComplete,
  vt as livePreviewSlotsInUse,
  xt as resetLivePreviewSlots,
  rt as scrollFractionOf,
  nt as scrollTopForFraction,
  Pe as seedAnswerForAsk,
  ze as setFeedbackRespondAnswer,
  kt as useLivePreviewSlot
};
//# sourceMappingURL=feedback-ui.js.map
